<div
  [hidden]="!active"
  class="'pane {{ customClass }}"
  [ngStyle]="{
    'background-color': color
  }"
>
  <ng-content></ng-content>
</div>
